import { useState, Fragment } from "react";
import useInput from "../hooks/use-input";
import classes from "./BasicForm.module.css";
import GetUsername from "./GetUsername";

const isNotEmpty = (value) => value.trim() !== "";
const isEmail = (value) => value.includes("@");
const isLongEnough = (value) => value.length > 8;

const insertRecord = async function (voornaam, achternaam, email, password) {
  console.log(voornaam, achternaam, email, password);

  const response = await fetch(
    "https://www.marchouben.nl/php/inloggegevens-post.php",
    {
      method: "POST",
      body: JSON.stringify({
        voornaam: voornaam,
        achternaam: achternaam,
        email: email,
        password: password,
      }),
      headers: {
        "Content-Type": "text/plain",
      },
    }
  );

  console.log(response);

  if (!response.ok) {
    throw new Error("Something went wrong!");
  }

  const data = await response.json();
  console.log(data);
  console.log(data.status);

  if (data.error !== "") {
    //setError("Something went wrong: " + data.error);
    throw new Error("Something went wrong: " + data.error);
  }

  // Dit zorgt voor oneindige LOOP
  //insertRecord().catch((error) => {
  //  console.log(error.message);
  //  throw new Error("Something went wrong!");
  //});
};

// Aliassen zijn nodig om het uniek te maken, omdat je 4 keer useInput gebruikt.
const BasicForm = () => {
  //const [error, setError] = useState("Houston, we have a problem");
  const [error, setError] = useState("");

  const {
    value: firstNameValue,
    isValid: firstNameIsValid,
    hasError: firstNameHasError,
    valueChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstName,
    inputFocusHandler: firstNameFocusHandler,
    isFocus: firstNameIsFocus,
  } = useInput(isNotEmpty);

  const {
    value: lastNameValue,
    isValid: lastNameIsValid,
    hasError: lastNameHasError,
    valueChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetLastName,
    inputFocusHandler: lastNameFocusHandler,
    isFocus: lastNameIsFocus,
  } = useInput(isNotEmpty);

  const {
    value: emailValue,
    isValid: emailIsValid,
    hasError: emailHasError,
    valueChangeHandler: emailChangeHandler,
    inputBlurHandler: emailBlurHandler,
    reset: resetEmail,
    inputFocusHandler: emailFocusHandler,
    isFocus: emailIsFocus,
  } = useInput(isEmail);

  const {
    value: passwordValue,
    isValid: passwordIsValid,
    hasError: passwordHasError,
    valueChangeHandler: passwordChangeHandler,
    inputBlurHandler: passwordBlurHandler,
    reset: resetPassword,
    inputFocusHandler: passwordFocusHandler,
    isFocus: passwordIsFocus,
  } = useInput(isLongEnough);

  let formIsValid = false;

  if (firstNameIsValid && lastNameIsValid && emailIsValid && passwordIsValid) {
    formIsValid = true;
  }

  const submitHandler = (event) => {
    event.preventDefault();

    if (!formIsValid) {
      return;
    }

    //console.log("Submitted Values");
    //console.log(firstNameValue, lastNameValue, emailValue, passwordValue);

    // Gegevens opslaan
    insertRecord(firstNameValue, lastNameValue, emailValue, passwordValue);

    resetFirstName();
    resetLastName();
    resetEmail();
    resetPassword();
  };

  const firstNameClasses = firstNameHasError
    ? "form-control invalid"
    : "form-control";

  const lastNameClasses = lastNameHasError
    ? "form-control invalid"
    : "form-control";

  const emailClasses = emailHasError ? "form-control invalid" : "form-control";

  const passwordClasses = passwordHasError
    ? "form-control invalid"
    : "form-control";

  const resetHandler = () => {
    resetFirstName();
    resetLastName();
    resetEmail();
    resetPassword();
    setError("");
  };

  return (
    <Fragment>
      <form onSubmit={submitHandler}>
        <div className="control-group">
          <div className={firstNameClasses}>
            <label htmlFor="voornaam">Voornaam</label>
            <input
              type="text"
              id="voornaam"
              value={firstNameValue}
              onChange={firstNameChangeHandler}
              onBlur={firstNameBlurHandler}
              onFocus={firstNameFocusHandler}
            />
            {firstNameHasError && (
              <p className="error-text">Vul een voornaam in.</p>
            )}
            {firstNameIsFocus && (
              <p className="info-text">Voornaam mag niet leeg zijn.</p>
            )}
          </div>

          <div className={lastNameClasses}>
            <label htmlFor="achternaam">Achternaam</label>
            <input
              type="text"
              id="achternaam"
              value={lastNameValue}
              onChange={lastNameChangeHandler}
              onBlur={lastNameBlurHandler}
              onFocus={lastNameFocusHandler}
            />
            {lastNameHasError && (
              <p className="error-text">Vul een achternaam in.</p>
            )}
            {lastNameIsFocus && (
              <p className="info-text">Achternaam mag niet leeg zijn.</p>
            )}
          </div>
        </div>

        <div className="control-group">
          <div className={emailClasses}>
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              value={emailValue}
              onChange={emailChangeHandler}
              onBlur={emailBlurHandler}
              onFocus={emailFocusHandler}
            />
            {emailHasError && (
              <p className="error-text">Vul een geldig email adres in.</p>
            )}
            {emailIsFocus && (
              <p className="info-text">Email moet een @ bevatten.</p>
            )}
          </div>

          <div className={passwordClasses}>
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={passwordValue}
              onChange={passwordChangeHandler}
              onBlur={passwordBlurHandler}
              onFocus={passwordFocusHandler}
            />
            {passwordHasError && (
              <p className="error-text">Vul een geldig wachtwoord in.</p>
            )}
            {passwordIsFocus && (
              <p className="info-text">
                Wachtwoord moet minimaal 9 posities lang zijn.
              </p>
            )}
          </div>
        </div>
        <div className="form-actions">
          <button onClick={resetHandler}>Reset</button>
          <button disabled={!formIsValid}>Verzenden</button>
        </div>
        {error.length !== 0 && <p className={classes.foutmelding}>{error}</p>}
      </form>
      {emailValue.length !==0 && <GetUsername email={emailValue} />}
    </Fragment>
  );
};

export default BasicForm;
